import { CxsBasket } from '../model';

export const setDeliveryMethod = (basket: CxsBasket, deliveryMethod: string): CxsBasket => ({
    ...basket,
    deliveryMethod
});
